<template>
  <div>
    <Calendar id="startDate" v-model="startDate" @input="emit"/>
    <Calendar id="endDate" v-model="endDate" @input="emit"/>
    <form @submit.prevent="submit">
      <div class="form-row">
        <div class="col-12 col-md-2">
          <div class="form-group">
            <select class="form-control" v-model="completed">
              <option :value="null">Todas</option>
              <option :value="true">Finalizadas</option>
              <option :value="false">Pendentes</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" type="text" placeholder="Nome" id="name" v-model="name"/>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" type="text" placeholder="CPF/CNPJ" v-mask="['###.###.###-##', '##.###.###/####-##']"
                id="taxDocument" v-model="taxDocument"/>
            </div>
            <p class="text-danger" v-if="!$v.taxDocument.cpfCnpj">
              <small>
                <i class="icon-exclamation"></i>&nbsp;
                Número de documento inválido
              </small>
            </p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" type="text" placeholder="Aplicativo" id="applicationName" v-model="applicationName"/>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <select class="form-control" v-model="searchByDateType">
              <option :value="null">Selecione o tipo de data a ser pesquisada</option>
              <option :value="'creationDate'">Data de geração da ocorrência</option>
              <option :value="'completionDate'">Data de finalização da ocorrência</option>
              <option :value="'creditScheduleDate'">Data prevista para crédito</option>
            </select>
            <p class="text-danger" v-if="!$v.searchByDateType.required">
              <small>
                <i class="icon-exclamation"></i>&nbsp;
                Informe o tipo de data a ser pesquisada
              </small>
            </p>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="input-group">
              <div class="form-control">
                <span v-if="startDate">
                  <small class="text-secondary">de</small>
                  &nbsp;{{ startDate | date }}
                  <a href="#" class="text-danger pl-2" @click.prevent="resetStartDate">&times;</a>
                </span>
                <span class="text-secondary" v-else>
                  data inicial
                </span>
              </div>
              <div class="input-group-append">
                <button type="button" class="btn btn-info" data-toggle="modal" data-target="#startDate">
                  <i class="icon-calendar"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <div class="input-group">
              <div class="form-control">
                <span v-if="endDate">
                  <small class="text-secondary">até</small>
                  &nbsp;{{ endDate | date }}
                  <a href="#" class="text-danger pl-2" @click.prevent="resetEndDate">&times;</a>
                </span>
                <span class="text-secondary" v-else>
                  data final
                </span>
              </div>
              <div class="input-group-append">
                <button type="button" class="btn btn-info" data-toggle="modal" data-target="#endDate">
                  <i class="icon-calendar"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 col-md-3 mt-2 ml-1">
          <div class="form-group">
            <label class="radio-selector d-flex">
              <input
                type="checkbox"
                v-model="autoAnticipation"
              />
              <div class="checkbox-badge mt-1 mr-2"></div>
              <h4 class="mb-0 mt-1 d-flex">Antecipação automática</h4>
            </label>
          </div>
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-info mr-2">
            <i class="icon-magnifier"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="reset">
            <i class="icon-trash"></i>
          </button>
        </div>
      </div>
    </form>
    <p class="text-danger" v-if="!$v.startDate.lowerThanEnd">
      <small>
        <i class="icon-exclamation"></i>&nbsp;
        A data de início deve ser anterior a data de término
      </small>
    </p>
    <p class="text-danger" v-if="!$v.startDate.required">
      <small>
        <i class="icon-exclamation"></i>&nbsp;
        Informe pelo menos uma data inicial ou final
      </small>
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { cpfCnpj } from '@/validations/cpfCnpj'

export default {
  name: 'OccurrenceListFilter',
  props: ['value'],
  data () {
    return {
      completed: null,
      startDate: null,
      endDate: null,
      name: null,
      taxDocument: '',
      applicationName: null,
      searchByDateType: null,
      autoAnticipation: null
    }
  },
  validations: {
    startDate: {
      lowerThanEnd () {
        return !this.startDate || !this.endDate || moment(this.startDate).isSameOrBefore(this.endDate)
      },
      required: requiredIf(function () {
        return this.searchByDateType != null && (this.startDate == null && this.endDate == null)
      })
    },
    searchByDateType: {
      required: requiredIf(function () {
        return this.startDate != null || this.endDate != null
      })
    },
    taxDocument: {
      cpfCnpj
    }
  },
  methods: {
    emit () {
      this.$emit('input', {
        completed: this.completed,
        startDate: this.startDate,
        endDate: this.endDate,
        searchByDateType: this.searchByDateType,
        name: this.name,
        taxDocument: this.taxDocument,
        applicationName: this.applicationName,
        autoAnticipation: this.autoAnticipation,
        index: 0,
        length: 10
      })
    },
    reset () {
      this.completed = null
      this.startDate = null
      this.endDate = null
      this.name = null
      this.taxDocument = ''
      this.applicationName = null
      this.searchByDateType = null
      this.autoAnticipation = null

      this.emit()
    },
    resetStartDate () {
      this.startDate = null
      this.emit()
    },
    resetEndDate () {
      this.endDate = null
      this.emit()
    },
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) return

      this.emit()
      this.$emit('submit')
    }
  }
}
</script>
